import {Container,Button, Col} from 'react-bootstrap';
import Navegacion from "./componentes/navegacion"
function App() {
  return (
   
      <Navegacion/>
  
  );
}

export default App;
